jQuery(function ($) {
    // Note that the code below assumes that the Mautic sign-up form has
    // already been added to the DOM. This is currently being done through a
    // snippet of JavaScript loaded from Mautic that runs synchronously, so it
    // is guaranteed to happen before the DOMReady event that triggers this
    // code here.

    // Initialize "Hoe heb je van ons gehoord?" field from URL parameter (used
    // by third parties to link to our sign-up form).
    $('select[data-init-from-url]').each(function(index, select) {
        select = $(select);
        const urlParameter = select.attr('data-init-from-url');
        // TODO reinstate option "Anders, namelijk..."
        const referenceParam = getUrlParameter(urlParameter);
        if (referenceParam) {
            const option = select
                .find('option')
                .filter((idx, option) => option.value == referenceParam);
            if (option.length > 0) {
                select.val(option[0].value);
            }
        }
    });
    $('input[data-init-from-url]').each(function(index, input) {
        input = $(input);
        const urlParameter = input.attr('data-init-from-url');
        const value = getUrlParameter(urlParameter);
        if (value) {
            input.val(value);
        }
    });

    // Initialize start date field.
    $('input[type="date"][data-min-days-from-now][data-max-days-from-now]').each(function(index, input) {
        input = $(input);
        const minDaysFromNow = parseInt(input.attr('data-min-days-from-now'));
        const maxDaysFromNow = parseInt(input.attr('data-max-days-from-now'));

        const today = new Date();
        const defaultDate = new Date();
        defaultDate.setDate(today.getDate() + minDaysFromNow);

        input.attr('type', 'text'); // Suppress browser date picker UI.
        input.attr('value', toDateInputValue(defaultDate));
        input.attr('readonly', true); // Prevent manual editing (date picker does not validate).
        $(input).datepicker({
            dateFormat: 'yy-mm-dd', // Expected by Mautic, do not change. Note that yy means a 4-digit year.
            defaultDate: defaultDate,
            minDate: minDaysFromNow,
            maxDate: maxDaysFromNow,
            showOtherMonths: true,
            selectOtherMonths: true,
        });
    });

    // Initialize automatically shown/hidden fields. On the input field
    // attributes in Mautic, set data-if-matches-regexp="..." to a regular
    // expression, and set data-if-matches-show="..." to a CSS selector. If the
    // value of the field matches the regexp, the selected elements are shown.
    $('input[data-if-matches-regexp][data-if-matches-show]').each(function(index, input) {
        input = $(input);
        const regexp = new RegExp(input.attr('data-if-matches-regexp'));
        const showFieldSelector = input.attr('data-if-matches-show');

        function updateVisibility() {
            const field = $(showFieldSelector);
            console.log(showFieldSelector, field.length);
            if (regexp.test(input.val())) {
                field.slideDown(400);
            } else {
                field.slideUp(400);
            }
        }

        updateVisibility();
        input.on('change input', updateVisibility);
    });
});

function toDateInputValue(date) {
    const local = new Date(date);
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return local.toJSON().slice(0, 10);
}

function getUrlParameter(name) {
    const url = window.location.href;
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (results) {
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    } else {
        return null;
    }
}
